export const environment = {
  production: false,
  appUrl: 'https://kirche-aachen.mobilesol.de',
  serviceUrl: 'https://kirche-aachen.mobilesol.de/v1',
  version: '-44f059d',
  buildtime: '251110-200157d'
};
